<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('grossProfitCustomer.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('grossProfitCustomer.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <div class="form-group">
          <ts-card>
            <ts-card-wrapper>
              <ts-loading-banner :loading="loading">
                <form>
                  <fieldset>
                    <legend>{{ $t('grossProfitCustomer.criteria') }}</legend>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('grossProfitCustomer.date')
                          }}</label>
                          <a-range-picker
                            v-model="model.date_range"
                            format="DD-MM-YYYY"
                            valueFormat="DD-MM-YYYY"
                            :ranges="{
                              Today: [
                                moment().format('DD-MM-YYYY'),
                                moment().format('DD-MM-YYYY')
                              ],
                              'This Month': [
                                moment().startOf('month'),
                                moment().endOf('month')
                              ]
                            }"
                          >
                            <template slot="renderExtraFooter"></template>
                          </a-range-picker>
                          <div class="validate" v-if="errors.has('date_range')">
                            {{ errors.first('date_range') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label class="required">{{
                            $t('grossProfitCustomer.branch')
                          }}</label>
                          <a-select
                            v-model="model.branch_id"
                            mode="multiple"
                            :options="branches"
                            class="ts-w-full"
                            @change="onChangeBranch"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                          ></a-select>
                          <div class="validate" v-if="errors.has('branch_id')">
                            {{ errors.first('branch_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('grossProfitCustomer.location')
                          }}</label>
                          <a-select
                            v-model="model.location_id"
                            :defaultActiveFirstOption="true"
                            mode="multiple"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :options="locations"
                            :placeholder="$t('all')"
                            class="ts-w-full"
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('location_id')"
                          >
                            {{ errors.first('location_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('grossProfitCustomer.category')
                          }}</label>

                          <a-select
                            v-model="model.category_id"
                            mode="multiple"
                            :defaultActiveFirstOption="true"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :options="productCategoryOptions"
                            :placeholder="$t('all')"
                            class="ts-w-full"
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('category_id')"
                          >
                            {{ errors.first('category_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>{{
                            $t('grossProfitCustomer.productGroup')
                          }}</label>

                          <a-select
                            v-model="model.product_group_id"
                            mode="multiple"
                            :defaultActiveFirstOption="true"
                            showSearch
                            :filterOption="
                              (input, option) =>
                                option.componentOptions.children[0].text
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                            "
                            :options="productGroupOptions"
                            :placeholder="$t('all')"
                            class="ts-w-full"
                          ></a-select>
                          <div
                            class="validate"
                            v-if="errors.has('product_group_id')"
                          >
                            {{ errors.first('product_group_id') }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label>
                          {{ $t('grossProfitCustomer.product') }}
                        </label>
                        <a-select
                          style="width: 100%"
                          mode="multiple"
                          placeholder="All"
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          v-model="model.product_id"
                          :options="productOptions"
                          @search="handleSearchProduct"
                        ></a-select>
                        <div class="validate" v-if="errors.has('product_id')">
                          {{ errors.first('product_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label>{{
                          $t('grossProfitCustomer.customerType')
                        }}</label>
                        <a-select
                          style="width:100%"
                          mode="multiple"
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          v-model="model.cus_type_id"
                          :options="customerTypes"
                          placeholder="All"
                        ></a-select>
                        <div class="validate" v-if="errors.has('cus_type_id')">
                          {{ errors.first('cus_type_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label>{{ $t('grossProfitCustomer.customers') }}</label>
                        <a-select
                          style="width:100%"
                          mode="multiple"
                          :filterOption="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          v-model="model.customer_id"
                          :options="customers"
                          placeholder="All"
                        ></a-select>
                        <div class="validate" v-if="errors.has('customer_id')">
                          {{ errors.first('customer_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <a-radio-group
                        v-model="model.report_type"
                        class="col-md-12"
                      >
                        <a-radio-button value="1" class="col-md-6"
                          >Summary</a-radio-button
                        >
                        <a-radio-button value="2" class="col-md-6"
                          >Details</a-radio-button
                        >
                      </a-radio-group>
                    </div>
                    <div class="row">
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          outline
                          color="success"
                          class="btn-block"
                          @click.prevent="exportExcel"
                          :waiting="exporting"
                          ><i class="far fa-file-excel"></i>
                          {{ $t('export') }}</ts-button
                        >
                      </div>
                      <div class="col-md-6 ts-text-right">
                        <ts-button
                          color="primary"
                          outline
                          class="btn-block"
                          @click.prevent="preview"
                          :waiting="waiting"
                          ><i class="far fa-file-pdf"></i>
                          {{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </fieldset>
                </form>
              </ts-loading-banner>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>{{ $t('grossProfitCustomer.preview') }}</legend>
                <ts-preview-pdf v-model="waiting" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions } from 'vuex'
import * as FileDownload from 'downloadjs'
import { trim, includes, debounce } from 'lodash'

export default {
  name: 'grossProfitCustomer',
  data() {
    return {
      waiting: false,
      exporting: false,
      loading: false,
      locationLoading: false,
      errors: new Errors(),
      locations: [],
      branches: [],
      productCategoryOptions: [],
      productGroupList: [],
      productOptions: [],
      customerTypes: [],
      src: '',
      customers: [],
      model: {
        report_type: '1',
        location_id: undefined,
        category_id: undefined,
        product_group_id: undefined,
        product_id: undefined,
        date_range: [
          moment().format('DD-MM-YYYY'),
          moment().format('DD-MM-YYYY')
        ],
        branch_id: []
      }
    }
  },
  computed: {
    productGroupOptions() {
      if (
        Array.isArray(this.model.category_id) &&
        this.model.category_id.length
      ) {
        return this.productGroupList
          .filter(p => includes(this.model.category_id, p.category_id))
          .map(el => ({
            value: el.pro_group_id,
            label: el.pro_group_name_en
          }))
      }

      return []
    }
  },
  created() {
    this.fetchLocation()
  },
  methods: {
    ...mapActions('report/finance', [
      'getBranch',
      'productCategory',
      'productGroup',
      'productProfileLocation',
      'customerProfile',
      'customerType',
      'grossProfitCustomer'
    ]),
    handleSearchProduct: debounce(async function(value) {
      if (!value) return false
      this.fetchProduct(value)
    }, 500),
    moment,
    async fetchLocation() {
      this.loading = true

      let productCategory = await this.productCategory()
      this.productCategoryOptions = productCategory.data.map(el => ({
        value: el.category_id,
        label: el.category_name_en
      }))

      let pgroup = await this.productGroup()
      this.productGroupList = pgroup.data

      await this.customerProfile()
        .then(response => {
          this.customers = response.data.map(el => ({
            value: el.customer_id,
            label: el.customer_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.customerType()
        .then(response => {
          this.customerTypes = response.map(el => ({
            value: el.cus_type_id,
            label: el.customer_type
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })

      await this.fetchProduct()

      await this.getBranch()
        .then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
          this.model.branch_id = [
            this.$store.state.authUser.user.default_branch.branch_id
          ]
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
          this.onChangeBranch()
        })
    },
    fetchProduct(value) {
      this.model.product_id = undefined
      this.loading = true
      this.productProfileLocation({
        searchProduct: value,
        filter: {
          pro_group_id: _.join(this.model.product_group_id, ','),
          category_id: _.join(this.model.category_id, ',')
        }
      })
        .then(response => {
          this.productOptions = response.data.map(el => ({
            value: el.product_id,
            label: el.product_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onChangeBranch() {
      this.locationLoading = true
      this.locations = []
      this.model.location_id = undefined
      this.$store
        .dispatch('report/resource/getLocation', {
          branch_id: this.model.branch_id
        })
        .then(response => {
          this.locations = response.data.map(el => ({
            value: el.location_id,
            label: el.location_name_en
          }))
        })
        .finally(() => {
          this.locationLoading = false
        })
    },
    preview() {
      this.waiting = true
      this.src = ''
      this.errors = new Errors()
      this.grossProfitCustomer(this.model)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    exportExcel() {
      this.exporting = true
      this.errors = new Errors()

      this.$store
        .dispatch('report/finance/grossProfitCustomerExcel', this.model)
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit(
      'report/inventory/SET_DATE_FROM',
      moment().format('DD-MM-YYYY')
    )
    this.$store.commit(
      'report/inventory/SET_DATE_TO',
      moment().format('DD-MM-YYYY')
    )
    next()
  }
}
</script>
